export const SHORT_LINK_PAY_TEST_NAME = 'DEV 1677 | Youth payment link';
